import React, { useEffect, useState } from "react";
import { utils } from "ethers";
import Footer from "../components/footer";
import { create } from "ipfs-http-client";
import { CountryList } from "../components/CountryList";
import { useEthers, useContractFunction } from "@usedapp/core";
import useFormsInput from "../../hooks/useFormsInput";
import { LoadingModal } from "../ui/Modals";
import { useContractContext } from "../../hooks/useContractContext";

const infufaClient = create("https://ipfs.infura.io:5001/api/v0");

const Createpage = () => {
  const {copyrightsContract} = useContractContext();
  const { account, activateBrowserWallet } = useEthers();
  // variables to capture image
  const [copyrightTarget, setCopyrightTarget] = useState();
  const [fileUpload, setFileUpload] = useState([]);
  const [uploadPreview, setUploadPreview] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [formIsValid, setFormIsValid] = useState(true);

  // form inputs
  const {
    // captured values and the corresponding handlers/trackers
    value: enteredDescription,
    isValid: enteredDescriptionIsValid,
    hasError: descriptionInputHasError,
    valueChangeHandler: descriptionChangedHandler,
    inputBlurHandler: descriptionBlurHandler,
    reset: resetDescriptionInput,
  } = useFormsInput((value) => value.trim() !== "");
  // Function used to check error. An example of an alternative checking function would be ((value) => value >= 0)
  const {
    value: enteredTitleOfWork,
    isValid: enteredTitleOfWorkIsValid,
    hasError: titleOfWorkInputHasError,
    valueChangeHandler: titleOfWorkChangedHandler,
    inputBlurHandler: titleOfWorkBlurHandler,
    reset: resetTitleOfWorkInput,
  } = useFormsInput((value) => value.trim() !== "");
  // const {
  //   value: enteredTypeOfWork,
  //   isValid: enteredTypeOfWorkIsValid,
  //   hasError: typeOfWorkInputHasError,
  //   valueChangeHandler: typeOfWorkChangedHandler,
  //   inputBlurHandler: typeOfWorkBlurHandler,
  //   reset: resetTypeOfWorkInput,
  // } = useFormsInput((value) => value.trim() !== "");
  const {
    value: enteredPseudonym,
    isValid: enteredPseudonymIsValid,
    hasError: pseudonymInputHasError,
    valueChangeHandler: pseudonymChangedHandler,
    inputBlurHandler: pseudonymBlurHandler,
    reset: resetPseudonymInput,
  } = useFormsInput((value) => value.trim() !== "");
  const {
    value: enteredYearCreated,
    isValid: enteredYearCreatedIsValid,
    hasError: yearCreatedInputHasError,
    valueChangeHandler: yearCreatedChangedHandler,
    inputBlurHandler: yearCreatedBlurHandler,
    reset: resetYearCreatedInput,
  } = useFormsInput((value) => value >= 1851 && value <= 2022);
  const {
    value: enteredFullName,
    isValid: enteredFullNameIsValid,
    hasError: fullNameInputHasError,
    valueChangeHandler: fullNameChangedHandler,
    inputBlurHandler: fullNameBlurHandler,
    reset: resetFullNameInput,
  } = useFormsInput((value) => value.trim() !== "");
  const {
    value: enteredUniqueIdentity,
    isValid: enteredUniqueIdentityIsValid,
    hasError: uniqueIdentityInputHasError,
    valueChangeHandler: uniqueIdentityChangedHandler,
    inputBlurHandler: uniqueIdentityBlurHandler,
    reset: resetUniqueIdentityInput,
  } = useFormsInput((value) => value.trim() !== "");
  const {
    value: enteredCitizenship,
    isValid: enteredCitizenshipIsValid,
    hasError: citizenshipInputHasError,
    valueChangeHandler: citizenshipChangedHandler,
    inputBlurHandler: citizenshipBlurHandler,
    reset: resetCitizenshipInput,
  } = useFormsInput((value) => value !== "");

  function uploadFileChangeHandler(event) {
    var files = event.target.files;
    setCopyrightTarget(files[0]);
    var filesArr = Array.prototype.slice.call(files);
    document.getElementById("file_name").style.display = "none";

    setFileUpload((prevState) => [prevState, ...filesArr]);
    setUploadPreview(URL.createObjectURL(files[0]));
  }

  const uploadtoIPFS = async (file) => {
    try {
      const added = await infufaClient.add(file);
      console.log(`https://nftstorage.link/ipfs/ipfs/${added.path}`);
      return added.path;
    } catch (error) {
      console.log("Error uploading file: ", error);
    }
  };

  const generateTokenURI = async () => {
    // 2 steps, (1) upload image to IPFS, retrive imageCID

    const imageCID = "ipfs://ipfs/".concat(await uploadtoIPFS(copyrightTarget));
    // (2) upload metaData to IPFS, retrive metaDataCID (a.k.a TokenURI)
    const metaData = {
      title: enteredTitleOfWork,
      description: enteredDescription,
      creator: enteredPseudonym,
      imageCID: imageCID,
      // work_type: enteredTypeOfWork,
      work_type: "Artistic",
      yearCreated: enteredYearCreated,
    };
    const metaDataJson = JSON.stringify(metaData);
    const metaDataCID = "ipfs://ipfs/".concat(await uploadtoIPFS(metaDataJson));
    return { metaDataCID, imageCID };
  };

  // usedapp's contractFunction hook  
  const { state: safeMintState, send: sendSafeMint } = useContractFunction(copyrightsContract, "safeMint");

  const submitNewCopyright = async () => {
    console.log("button Triggered");
    // STEP 1: upload files to IPFS, generate imageCid & metaDataCid (a.k.a TokenURI)
    if (!account) {
      activateBrowserWallet();
    }
    setIsLoading(true);
    const { metaDataCID, imageCID } = await generateTokenURI();

    // for now assuming creator Address is the sender. Future addition could allow the form to put in a different address
    // e.g. for the case of an admin submitting on behalf of the creator

    // STEP 2 : combine first+last name, then convert private data to bytes
    const fullName = enteredFullName.trim();
    const country = enteredCitizenship.trim();

    const fullNameBytes = utils.toUtf8Bytes(fullName.toUpperCase());
    const countryCombinedBytes = utils.toUtf8Bytes(country.toUpperCase());
    const uniqIdenBytes = utils.toUtf8Bytes(enteredUniqueIdentity.toUpperCase());

    // temp
    const enteredTypeOfWork = "Artistic";

    // // STEP 3: submit details to the blockchain (i.e. trigger mint Function)
    await sendSafeMint(
      account,
      metaDataCID,
      enteredPseudonym,
      enteredTypeOfWork,
      enteredYearCreated,
      imageCID,
      utils.sha256(fullNameBytes),
      utils.sha256(countryCombinedBytes),
      utils.sha256(uniqIdenBytes)
    );
    setIsLoading(false);
  };

  useEffect(() => {
    if (
      uploadPreview &&
      enteredDescriptionIsValid &&
      enteredTitleOfWorkIsValid &&
      // enteredTypeOfWorkIsValid &&
      enteredPseudonymIsValid &&
      enteredYearCreatedIsValid &&
      enteredFullNameIsValid &&
      enteredUniqueIdentityIsValid &&
      enteredCitizenshipIsValid
    ) {
      setFormIsValid(true);
    } else {
      setFormIsValid(false);
    }
  }, [
    uploadPreview,
    enteredDescriptionIsValid,
    enteredTitleOfWorkIsValid,
    // enteredTypeOfWorkIsValid,
    enteredPseudonymIsValid,
    enteredYearCreatedIsValid,
    enteredFullNameIsValid,
    enteredUniqueIdentityIsValid,
    enteredCitizenshipIsValid,
  ]);

  useEffect(() => {
    if (safeMintState.status === "Success") {
      resetDescriptionInput();
      resetTitleOfWorkInput();
      // resetTypeOfWorkInput();
      resetPseudonymInput();
      resetYearCreatedInput();
      resetFullNameInput();
      resetUniqueIdentityInput();
      resetCitizenshipInput();
    }

    // eslint-disable-next-line
  }, [safeMintState]);

  return (
    <div>
      {isLoading && safeMintState.status !== "Mining" && <LoadingModal title={"Loading..."}/>}
      {safeMintState.status === "Mining" && <LoadingModal title={"Mining..."}/>}
      <section className="jumbotron breadcumb no-bg">
        <div className="mainbreadcumb">
          <div className="container">
            <div className="row m-10-hor">
              <div className="col-12">
                <h1 className="text-center">Create Record</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="container">
        <div className="row">
          <div className="col-lg-7 offset-lg-1 mb-5">
            <form id="form-create-item" className="form-border" action="#">
              <div className="field-set">
                <h5>Upload file</h5>
                <div className="d-create-file">
                  <p id="file_name">PNG, JPG, Max 15mb.</p>
                  {fileUpload.map((x) => (
                    <p key={x}>PNG, JPG, Max 15mb{x.name}</p>
                  ))}
                  <div className="browse">
                    <input type="button" id="get_file" className="btn-main" value="Browse" />
                    <input id="upload_file" type="file" multiple onChange={uploadFileChangeHandler} />
                  </div>
                </div>
                <div className="spacer-single"></div>
                <h5>Title</h5>
                <input
                  type="text"
                  name="item_title"
                  id="item_title"
                  className="form-control"
                  placeholder="e.g. 'Original Artwork"
                  onChange={titleOfWorkChangedHandler}
                  onBlur={titleOfWorkBlurHandler}
                  value={enteredTitleOfWork}
                />
                {titleOfWorkInputHasError && (
                  <p className="error-text">
                    <i className="fa fa-warning" />
                    Title field must not be empty.
                  </p>
                )}
                <div className="spacer-10"></div>
                <h5>Description</h5>
                <textarea
                  data-autoresize
                  name="item_desc"
                  id="item_desc"
                  className="form-control"
                  placeholder="e.g. 'Describe your artwork as if you were talking to someone who couldn't see it. Describe the mood of your artwork as well as the visual characteristics.'"
                  onChange={descriptionChangedHandler}
                  onBlur={descriptionBlurHandler}
                  value={enteredDescription}
                ></textarea>
                {descriptionInputHasError && (
                  <p className="error-text">
                    <i className="fa fa-warning" />
                    Description field must not be empty.
                  </p>
                )}
                <div className="spacer-20"></div>
                <h4>Work Details</h4>
                <div className="spacer-5"></div>
                <h5>Type of Work</h5>
                <select
                  name="item_workType"
                  id="item_workType"
                  className="form-control"
                  // onChange={typeOfWorkChangedHandler}
                  // onBlur={typeOfWorkBlurHandler}
                  // value={enteredTypeOfWork}
                  selectedValue="Artistic"
                >
                  <option value="Artistic">Artistic</option>
                  <option disabled>Literary</option>
                  <option disabled>Dramatic</option>
                  <option disabled>Musical</option>
                </select>
                {/* {typeOfWorkInputHasError && (
                  <p className="error-text">
                    <i className="fa fa-warning" />
                    Type Of Work must not be empty.
                  </p>
                )} */}
                <div className="spacer-5"></div>
                <h5>Creator Pseudonym</h5>
                <input
                  type="text"
                  name="creator_Pseudonym"
                  id="creator_Pseudonym"
                  className="form-control"
                  placeholder="e.g. 'Banksy'"
                  onChange={pseudonymChangedHandler}
                  onBlur={pseudonymBlurHandler}
                  value={enteredPseudonym}
                />
                {pseudonymInputHasError && (
                  <p className="error-text">
                    <i className="fa fa-warning" />
                    Pseudonym must not be empty.
                  </p>
                )}
                <div className="spacer-5"></div>
                <h5>Year created</h5>
                <input
                  type="number"
                  name="item_yearCreated"
                  id="item_yearCreated"
                  className="form-control"
                  min="1851"
                  max="2021"
                  step="10"
                  placeholder="e.g. '2021'"
                  onChange={yearCreatedChangedHandler}
                  onBlur={yearCreatedBlurHandler}
                  value={enteredYearCreated}
                />
                {yearCreatedInputHasError && (
                  <p className="error-text">
                    <i className="fa fa-warning" />
                    Year must be a valid number
                  </p>
                )}
                <div className="spacer-20"></div>
                <h4>National identity (Creator)</h4>
                <div className="spacer-10"></div>
                <h5> Full Name (as per National ID)</h5>
                <input
                  type="text"
                  name="creator_name"
                  id="creator_name"
                  className="form-control"
                  placeholder="e.g. 'John Doe'"
                  onChange={fullNameChangedHandler}
                  onBlur={fullNameBlurHandler}
                  value={enteredFullName}
                />
                {fullNameInputHasError && (
                  <p className="error-text">
                    <i className="fa fa-warning" />
                    Name must not be empty.
                  </p>
                )}
                <div className="spacer-5"></div>
                <h5>National Identification Number</h5>
                <input
                  type="text"
                  name="creator_uniqid"
                  id="creator_uniqid"
                  className="form-control"
                  placeholder="e.g. 'NRIC number / green card number'"
                  onChange={uniqueIdentityChangedHandler}
                  onBlur={uniqueIdentityBlurHandler}
                  value={enteredUniqueIdentity}
                />
                {uniqueIdentityInputHasError && (
                  <p className="error-text">
                    <i className="fa fa-warning" />
                    Unique identity field must not be empty.
                  </p>
                )}
                <h5>Country</h5>
                <CountryList
                  onChange={citizenshipChangedHandler}
                  onBlur={citizenshipBlurHandler}
                  enteredValue={enteredCitizenship}
                />
                {citizenshipInputHasError ||
                  (!enteredCitizenshipIsValid && (
                    <p className="error-text">
                      <i className="fa fa-warning" />
                      Please select a country
                    </p>
                  ))}
                <div className="spacer-10"></div>
                <button
                  disabled={!formIsValid || safeMintState.status === "Mining" || isLoading}
                  type="button"
                  id="submit"
                  className="btn-main"
                  onClick={submitNewCopyright}
                >
                  Claim Artwork
                </button>
                {!formIsValid && (
                  <p className="error-text">
                    <i className="fa fa-warning" />
                    Please check all the fields
                  </p>
                )}
                {safeMintState.status === "Mining" && (
                  <p className="error-text">
                    <i className="fa fa-warning" />
                    Mining transaction, please wait...
                  </p>
                )}
                {!safeMintState.status === "None" && <i className="">Transaction Status: {safeMintState.status}</i>}
                
              </div>
            </form>
          </div>

          <div className="col-lg-3 col-sm-6 col-xs-12">
            <h5>Preview picture</h5>
            <div className="nft__item m-0">
              <div className="nft__item_wrap">
                <span>
                  <img src={uploadPreview} id="get_file_2" className="lazy nft__item_preview" alt="" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Createpage;
